import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader';
import { ParsedWarningContent } from '../../services/warnings/severeWarnings';

const FallbackContent = ({ warning, isLoading, type }:
    { warning: ParsedWarningContent | null, isLoading: boolean, type: string, }
) => {
    if (isLoading || !warning) {
        return (
            <div className={'load-content'}>
                <ClipLoader
                    color={'#313638'}
                    loading={true}
                    size={35}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
            </div>
        );
    }
    return (
        <div dangerouslySetInnerHTML={{__html: warning.fallbackContent!}} />
    );
}

export default FallbackContent;
